import React, { useRef, useState, useEffect } from 'react'
import styles from './assets/TopPage.module.css'
import Cookies from 'universal-cookie'
import TopSpecialBanner from './TopSpecialBanner'
import Header from '../Header'
import Footer from '../Footer'
import { Link, useHistory, useLocation } from 'react-router-dom'
import top_banner_pc_01 from './assets/top_banner_pc_01.webp'
import top_banner_pc_02 from './assets/top_banner_pc_02.webp'
import top_banner_pc_03 from './assets/top_banner_pc_03.webp'
import top_banner_pc_04 from './assets/top_banner_pc_04.webp'
import icon_step_01 from './assets/icon_step_01.webp'
import icon_step_02 from './assets/icon_step_02.webp'
import icon_step_04 from './assets/icon_step_04.webp'
import icon_step_03 from './assets/icon_step_03.webp'
import icon_service_01_pc from './assets/icon_service_01_pc.webp'
import icon_service_02_pc from './assets/icon_service_02_pc.webp'
import icon_service_03_pc from './assets/icon_service_03_pc.webp'
import icon_service_04_pc from './assets/icon_service_04_pc.webp'
import icon_service_06_pc from './assets/icon_service_06_pc.webp'
import icon_service_07_pc from './assets/icon_service_07_pc.webp'
import title_pickup from './assets/title_pickup.webp'
import icon_service_05_pc from './assets/icon_service_05_pc.webp'
import title_new from './assets/title_new.webp'
import title_free from './assets/title_free.webp'
import title_keyword from './assets/title_keyword.webp'
import icon_arrow from './assets/icon_arrow.webp'
import icon_beginner from './assets/icon_beginner.svg'
import icon_create from './assets/icon_create.svg'
import { isMobile } from 'react-device-detect'
import { Top, FirstView } from 'apis/response_types'
import { getTop, getFirstView } from 'apis/top'
import ReactMarkdown from 'react-markdown'
import styled from 'styled-components'
import { spacesReg } from 'components/Header'
import { useDispatch } from 'react-redux'
import alertModules from 'modules/alert'
import CarouselBanner from 'components/landingpage/CarouselBanner'
import DoorList from './DoorList'
import {} from 'constants'
import { landingPageFixedKeywords } from '../../constants'
import { logger } from 'utils/logger'
import MetaTag from 'components/common/MetaTag'
import { creditcardAlertMessages } from 'containers/door/DoorDetail'

export const mobileDoorVolume = 8
export const doorVolume = 15

const banners = [
  {
    href: '/guideline',
    img: top_banner_pc_01,
    name: 'GUIDELINE'
  },
  {
    href: 'https://releasenotes.yoor.jp/#futureplans',
    img: top_banner_pc_02,
    name: 'UPDATE'
  },
  {
    href: '/beginner',
    img: top_banner_pc_03,
    name: 'BEGINNER'
  },
  {
    href: 'https://blog.yoor.jp/',
    img: top_banner_pc_04,
    name: 'MEDIA'
  }
]

const serviceList = [
  {
    title: '無料で使えるサロン専用トークルーム',
    img: icon_service_01_pc,
    contents: (
      <>
        YOORでは、オンラインサロンのために設計されたトークルームを各サロンにてご利用可能です。
        <br />
        プランやテーマごとに分かれたルーム内では、テキストや写真、動画を投稿することができる他、いいねやコメント、返信でサロン内のコミュニケーションを楽しむことができます
      </>
    )
  },
  {
    title: '多種多様なサロン',
    img: icon_service_02_pc,
    contents: (
      <>
        オンラインレッスンやファンクラブなど
        <br className={`${styles['pc-only']}`} />
        様々な用途でご利用いただけます
      </>
    )
  },
  {
    title: '豊富なプランと特典',
    img: icon_service_03_pc,
    contents: (
      <>
        トークルームと連動した、特典が異なる
        <br className={`${styles['pc-only']}`} />
        複数のプランをご利用いただけます
      </>
    )
  },
  {
    title: '充実サポート',
    img: icon_service_04_pc,
    contents: (
      <>
        メンバーのお問合せはもちろん、お困りのオーナー
        <br className={`${styles['pc-only']}`} />
        も専門スタッフがサポートします
      </>
    )
  },
  {
    title: '実名不要',
    img: icon_service_05_pc,
    contents: (
      <>
        YOORならメンバー、オーナーとも
        <br className={`${styles['pc-only']}`} />
        ニックネームでも参加できるので安心
      </>
    )
  },
  {
    title: '安心の管理体制',
    img: icon_service_06_pc,
    contents: (
      <>
        スタッフの定期巡回やキーワード自動検知で安心の
        <br className={`${styles['pc-only']}`} />
        体制。トラブル防止のためDM機能もありません
      </>
    )
  },
  {
    title: 'SNSの連携不要',
    img: icon_service_07_pc,
    contents: (
      <>
        SNSアカウントの連携が不要なの
        <br className={`${styles['pc-only']}`} />
        で安心してご利用いただけます
      </>
    )
  }
]

const processList = [
  {
    img: icon_step_01,
    content: (
      <>
        <h3 className={`${styles['process-step-title']}`}>
          参加希望のサロンにて
          <span className={`${styles['text-blue']}`}>「参加する」</span>
          ボタンをクリック
        </h3>
        <p className={`${styles['process-step-text']} ${styles['tb-only']}`}>
          Twitterを連携後、メールアドレスを認証してアカウントを登録しましょう
        </p>
        <p className={`${styles['process-step-text']} ${styles['pc-only']}`}>
          参加したいオンラインサロンページの「参加する」ボタンをクリック。
          <br />
          YOORにまだ会員登録していない方は、会員登録をお願いします。
        </p>
      </>
    )
  },
  {
    img: icon_step_02,
    content: (
      <>
        <h3 className={`${styles['process-step-title']}`}>
          クレジットカード登録
        </h3>
        <p className={`${styles['process-step-text']}`}>
          画面の指示に従って、お支払いに使うクレジットカードの登録をお願いします。
        </p>
      </>
    )
  },
  {
    img: icon_step_03,
    content: (
      <>
        <h3 className={`${styles['process-step-title']}`}>
          参加するプランを選択
        </h3>
        <p className={`${styles['process-step-text']}`}>
          オンラインサロンページから、参加したいプランを選択してください。
        </p>
      </>
    )
  },
  {
    img: icon_step_04,
    content: (
      <>
        <h3 className={`${styles['process-step-title']}`}>
          トークルームで
          <br className={`${styles['tb-only']}`} />
          オンラインサロンを楽しむ
        </h3>
        <p className={`${styles['process-step-text']}`}>
          YOOR独自のオンラインサロン専用トークルームで、オンラインサロンをお楽しみいただけます。
        </p>
      </>
    )
  }
]

export default function TopPageView() {
  const history = useHistory()
  //URLパラメータを文字列で取得(?含む)
  const viewVolume = isMobile ? mobileDoorVolume : doorVolume
  const [firstView, setFirstView] = useState<FirstView | null>(null)
  const [data, setData] = useState<Top | null>(null)
  const [keyword, setKeyword] = useState<string>('')
  const dispatch = useDispatch()

  const query = new URLSearchParams(useLocation().search)

  const getFirstViewData = async () => {
    await getFirstView()
      .then((response) => {
        setFirstView(response.data)
      })
      .catch((error) => {
        logger.debug(error)
      })
  }

  const getData = async () => {
    await getTop()
      .then((response) => {
        setData(response.data)
      })
      .catch((error) => {
        logger.debug(error)
      })
  }

  useEffect(() => {
    getFirstViewData()
    getData()
    // a8広告用
    if (query.get('a8') !== null) {
      const a8param = query.get('a8')
      const cookies = new Cookies()
      const expires = new Date()
      expires.setDate(expires.getDate() + 90)
      cookies.set('yoora8id', a8param, {
        secure: true,
        expires: expires,
        domain: '.yoor.jp'
      })
      cookies.set('yoora8expires', expires.getTime() / 1000, {
        secure: true,
        expires: expires,
        domain: '.yoor.jp'
      })
    }
  }, [])

  const handleSearchEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (keyword === '' || spacesReg.test(keyword)) {
      dispatch(
        alertModules.actions.setAlert({
          text: 'キーワードは必須です',
          severity: 'error'
        })
      )
      return
    }
    if (e.nativeEvent.isComposing || e.key !== 'Enter') return
    toSearch()
  }

  const toSearch = () => {
    history.push(`/search?keyword=${encodeURIComponent(keyword)}`)
  }

  //アラートの文字量で高さの変動に対応できないためアラートの高さを取得して動的に調整
  const alertRef = useRef<HTMLDivElement>(null)
  const [alertHeight, setAlertHeight] = useState(0)

  useEffect(() => {
    if (alertRef.current && firstView?.urgent && firstView?.creditcard_alert) {
      setAlertHeight(alertRef.current.clientHeight)
    }
  }, [firstView?.urgent, firstView?.creditcard_alert])

  const calculatedHeight = alertHeight
  const calculatedStyle = {
    top: `${calculatedHeight}px`
  }

  const [isActive, setIsActive] = useState(false)
  const handleButtonClick = () => {
    setIsActive(true)
    setIsActive(!isActive)
  }

  return (
    <>
      <Header onButtonClick={handleButtonClick} isActive={isActive} />
      <div className={`${styles['landingroot']}`}>
        <div ref={alertRef}>
          {/* 緊急告知 */}
          {firstView?.urgent && (
            <div
              className={`${styles['globalAlert']} globalAlert ${
                firstView?.urgent.urgency
              } ${isActive ? styles['is-active'] : ''}`}
            >
              <ReactMarkdown
                children={firstView?.urgent.body}
                linkTarget="_blank"
              ></ReactMarkdown>
            </div>
          )}
          {/* 支払い周りのアラート */}
          {firstView?.creditcard_alert && (
            <CreditcardAlert>
              <ReactMarkdown
                children={creditcardAlertMessages[firstView.creditcard_alert]}
              />
            </CreditcardAlert>
          )}
        </div>
        <MetaTag
          title="オンラインサロンならYOOR（ユア）- AI機能搭載"
          ogUrl="https://yoor.jp/"
          ogType="website"
          ogImage="https://yoor.jp/ogp.jpg"
          description="YOORは、サロン専用トークルームを完備した、コミュニティやファンクラブ、オンラインレッスンの場として利用できる業界初AI機能搭載のオンラインサロンプラットフォームです。"
        />
        <section className={`${styles['topimage']}`}>
          {/* 特集バナー */}
          {firstView?.special_banners &&
            firstView.special_banners.length !== 0 && (
              <div
                className={`${styles['topimage-banner-box']} ${styles['is-pcOnly']}`}
              >
                <TopSpecialBanner
                  banners={firstView.special_banners}
                  paginationClass="pc"
                />
              </div>
            )}
          <div className={`${styles['topimage-inner']}`}>
            <div className={`${styles['topimage-title-box']}`}>
              <p className={`${styles['topimage-title-appeal']}`}>
                流通取引総額<span className={`${styles['strong']}`}>16倍</span>
                成長<span className={`${styles['caution']}`}>※</span>
              </p>
              <h1 className={`${styles['topimage-title']}`}>
                <p
                  className={`${styles['topimage-title-text']} ${styles['text-blue']}`}
                >
                  オンラインサロンも、コミュニティも、
                </p>
                <br />
                <p className={`${styles['topimage-title-text']}`}>
                  YOORでつくろう
                </p>
              </h1>
              <p className={`${styles['topimage-lead']}`}>
                YOOR（ユア）は、コミュニティやファンクラブ、オンラインレッスンの
                <br className={`${styles['pc-only']}`} />
                場として利用できるオンラインサロンプラットフォームです。
              </p>
              <div className={`${styles['topimage-button-box']}`}>
                <Link
                  to="/signup"
                  className={`${styles['button']} ${styles['button-gra']}`}
                >
                  サロンを開設する
                  <span
                    className={`${styles['button']} ${styles['button-balloon']}`}
                  >
                    最短５分で開設
                  </span>
                </Link>
                <a
                  href="https://form.run/@yoor-document"
                  target="_blank"
                  className={`${styles['button']} ${styles['button-gra']} ${styles['-orange']}`}
                >
                  資料無料ダウンロード
                </a>
                <Link
                  to="/opensalon"
                  className={`${styles['button']} ${styles['button-white']} ${styles['is-arrow']}`}
                >
                  サロン開設について
                </Link>
              </div>
            </div>
            <div className={`${styles['yoor-record']}`}>
              <div className={`${styles['yoor-record-count']}`}>
                <span className={`${styles['yoor-record-title']}`}>
                  サロン開設数
                </span>
                <div className={`${styles['yoor-record-numWrap']}`}>
                  <span className={`${styles['yoor-record-num']}`}>
                    {firstView?.opened_salon_volume}
                  </span>
                  <span className={`${styles['yoor-record-unit']}`}>
                    サロン
                  </span>
                </div>
              </div>
              <div className={`${styles['yoor-record-divider']}`}></div>
              <div className={`${styles['yoor-record-count']}`}>
                <span className={`${styles['yoor-record-title']}`}>
                  取引件数
                </span>
                <div className={`${styles['yoor-record-numWrap']}`}>
                  <span className={`${styles['yoor-record-num']}`}>
                    {firstView?.billed_volume}
                  </span>
                  <span className={`${styles['yoor-record-unit']}`}>件</span>
                </div>
              </div>
            </div>
            {/* 特集バナー */}
            {firstView?.special_banners &&
              firstView.special_banners.length !== 0 && (
                <div
                  className={`${styles['topimage-banner-box']} ${styles['is-spOnly']}`}
                >
                  <TopSpecialBanner
                    banners={firstView.special_banners}
                    paginationClass="sp"
                  />
                </div>
              )}
            {/* 現状スライドの設定をする予定がないので一旦コメントアウト　 */}
            {/* HTMLファイルから取り込むのが面倒なので保持する */}
            {/* <div className={`${styles['topimage-slide']}`}>
              <div className={`${styles['topimage-slide-wrap']} ${styles['']}`}>
                <div className={`${styles['topimage-slide-bg']} ${styles['swiper']}`}>
                  <ul className={`${styles['topimage-slide-image-list']} ${styles['swiper-wrapper']}`}>
                    <li className={`${styles['topimage-slide-image-list-item']} ${styles['swiper-slide']}`}>
                      <div className={`${styles['topimage-slide-image-wrap']}`}>
                        <a
                          href=""
                          className={`${styles['topimage-slide-image']}`}
                          style={
                            {
                              // backgroundImage: `url(${recommend_image})`
                            }
                          }
                        ></a>
                      </div>
                    </li>
                    <li className={`${styles['topimage-slide-image-list-item']} ${styles['swiper-slide']}`}>
                      <div className={`${styles['topimage-slide-image-wrap']}`}>
                        <a
                          href=""
                          className={`${styles['topimage-slide-image']}`}
                          style={{
                            backgroundImage:
                              'url(https://placehold.jp/320x160.webp)'
                          }}
                        ></a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles['swiper-pagination']}`}></div>
            </div> */}
          </div>
        </section>

        {!(
          firstView?.carousel_banners && firstView.carousel_banners.length !== 0
        ) && (
          <section className={`${styles['topbanner']}`}>
            <div className={`${styles['topbanner-inner']}`}>
              <ul className={`${styles['topbanner-list']}`}>
                {banners.map((b, index) => {
                  return (
                    <li
                      key={index}
                      className={`${styles['topbanner-list-item']}`}
                    >
                      <p className={`${styles['topbanner-text']}`}>{b.name}</p>
                      {index === 2 ? (
                        <a
                          href={b.href}
                          className={`${styles['topbanner-link']}`}
                          style={{ backgroundImage: `url(${b.img})` }}
                        ></a>
                      ) : (
                        <a
                          href={b.href}
                          target="_blank"
                          className={`${styles['topbanner-link']}`}
                          style={{ backgroundImage: `url(${b.img})` }}
                        ></a>
                      )}
                    </li>
                  )
                })}
              </ul>
            </div>
          </section>
        )}

        <section
          className={`${styles['topservice']} ${
            firstView?.carousel_banners &&
            firstView.carousel_banners.length !== 0 &&
            styles['topbanner-hidden']
          }`}
        >
          {firstView?.carousel_banners &&
            firstView.carousel_banners.length !== 0 && (
              <div className={`${styles['carousel-banners']}`}>
                <CarouselBanner banners={firstView.carousel_banners} />
              </div>
            )}
          <div className={`${styles['topservice-inner']}`}>
            <h2 className={`${styles['topservice-title']}`}>
              <span className={`${styles['topservice-title-lead']}`}>
                オンラインサロンサービス
              </span>
              YOORをはじめよう
            </h2>
            <div className={`${styles['topservice-leadbox']}`}>
              <p className={`${styles['topservice-lead']}`}>
                YOOR（ユア）は、コミュニティやファンクラブ、オンラインレッスンの場として利用できる業界初AI機能搭載のオンラインサロンプラットフォームです。
                <br />
                クリエイター、インフルエンサー、ミュージシャン、専門家、著名人、ブロガーなど様々なオーナーがオンラインサロンを主催しています。
                <br />
                憧れの人との交流、学びの場、価値観が同じ仲間との出会いなど、新しい体験を提供できます。
              </p>
            </div>
            <ul className={`${styles['topservice-list']}`}>
              {serviceList.map((s, i) => {
                return (
                  <li
                    key={i}
                    className={`${styles['topservice-list-item']} ${
                      i == 0 ? styles['is-wide'] : ''
                    }`}
                  >
                    <div className={`${styles['topservice-number-box']}`}>
                      <p className={`${styles['topservice-number-text']}`}>
                        YOOR
                      </p>
                      <p className={`${styles['topservice-number']}`}>
                        #{i + 1}
                      </p>
                    </div>
                    {i == 0 ? (
                      <div className={`${styles['topservice-flex']}`}>
                        <div className={`${styles['topservice-image-box']}`}>
                          <img
                            src={s.img}
                            className={`${styles['topservice-image']}`}
                            alt="無料で使えるサロン専用トークルーム"
                          />
                        </div>
                        <div className={`${styles['topservice-content-wrap']}`}>
                          <div className={`${styles['topservice-content']}`}>
                            <h3
                              className={`${styles['topservice-list-title']}`}
                            >
                              {s.title}
                            </h3>
                            <p className={`${styles['topservice-list-lead']}`}>
                              {s.contents}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className={`${styles['topservice-image-box']}`}>
                          <img
                            src={s.img}
                            className={`${styles['topservice-image']}`}
                            alt="無料で使えるサロン専用トークルーム"
                          />
                        </div>
                        <div className={`${styles['topservice-content']}`}>
                          <h3 className={`${styles['topservice-list-title']}`}>
                            {s.title}
                          </h3>
                          <p className={`${styles['topservice-list-lead']}`}>
                            {s.contents}
                          </p>
                        </div>
                      </>
                    )}
                  </li>
                )
              })}
            </ul>
            <ul className={`${styles['topservice-button-list']}`}>
              <li className={`${styles['topservice-button-item']}`}>
                <Link
                  to="/opensalon"
                  className={`${styles['button']} ${styles['button-blue']} ${styles['is-text-center']}`}
                >
                  <span
                    className={`${styles['button']} ${styles['button-icon-arrow']}`}
                  >
                    サロン開設について
                  </span>
                </Link>
              </li>
              <li className={`${styles['topservice-button-item']}`}>
                <a
                  href="/beginner"
                  className={`${styles['button']} ${styles['button-blue']} ${styles['is-text-center']}`}
                >
                  <span
                    className={`${styles['button']} ${styles['button-icon-arrow']}`}
                  >
                    YOORとは？
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </section>
        <section className={`${styles['salonbanner']}`}>
          <div className={`${styles['salonbanner-content']}`}>
            <div className={`${styles['salonbanner_imageborder']}`}>
              <div className={`${styles['salonbanner_imagewrap']}`}>
                <Link
                  to="/opensalon"
                  className={`${styles['salonbanner-link']}`}
                ></Link>
              </div>
            </div>
          </div>
        </section>
        <section className={`${styles['recommend']} ${styles['is-gray']}`}>
          <div className={`${styles['recommend-inner']}`}>
            <div className={`${styles['recommend-content']}`}>
              <h2 className={`${styles['recommend-title']}`}>
                <div className={`${styles['recommend-title-text']}`}>
                  <span className={`${styles['recommend-title-color']}`}>
                    注目の
                  </span>
                  オンラインサロン
                </div>
              </h2>
              <div className={`${styles['recommend-list-wrap']}`}>
                <img
                  className={`${styles['recommend-title-image']}`}
                  src={title_pickup}
                  alt="pick up"
                />
                <DoorList
                  doors={data ? data.pickup.slice(0, viewVolume) : []}
                />
              </div>
              {/* https://github.com/seesaa/door/issues/2759#issuecomment-1469696232 */}
              {/* <div className={`${styles['recommend-button-box']}`}>
                <Link
                  to="/pickup"
                  className={`${styles['button']} ${styles['button-blue']}`}
                >
                  <span
                    className={`${styles['button']} ${styles['button-icon-arrow']}`}
                  >
                    注目のサロン一覧を見る
                  </span>
                </Link>
              </div> */}
            </div>
          </div>
        </section>
        <section className={`${styles['recommend']}`}>
          <div className={`${styles['recommend-inner']}`}>
            <div className={`${styles['recommend-content']}`}>
              <h2 className={`${styles['recommend-title']}`}>
                <div className={`${styles['recommend-title-text']}`}>
                  <span className={`${styles['recommend-title-color']}`}>
                    おすすめの新着
                  </span>
                  <br className={`${styles['tb-only']}`} />
                  オンラインサロン
                </div>
              </h2>
              <div className={`${styles['recommend-list-wrap']}`}>
                <img
                  className={`${styles['recommend-title-image']}`}
                  src={title_new}
                  alt="new salon"
                />
                <DoorList
                  doors={data ? data.recommend.slice(0, viewVolume) : []}
                />
              </div>
              <div className={`${styles['recommend-button-box']}`}>
                <Link
                  to="/newsalon"
                  className={`${styles['button']} ${styles['button-blue']}`}
                >
                  <span
                    className={`${styles['button']} ${styles['button-icon-arrow']}`}
                  >
                    新着サロン一覧を見る
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className={`${styles['recommend']}`}>
          <div className={`${styles['recommend-inner']}`}>
            <div className={`${styles['recommend-content']}`}>
              <h2 className={`${styles['recommend-title']}`}>
                <div className={`${styles['recommend-title-text']}`}>
                  <span className={`${styles['recommend-title-color']}`}>
                    無料
                  </span>
                  <br className={`${styles['tb-only']}`} />
                  オンラインサロン
                </div>
              </h2>
              <div className={`${styles['recommend-list-wrap']}`}>
                <img
                  className={`${styles['recommend-title-image']}`}
                  src={title_free}
                  alt="free salon"
                />
                <DoorList doors={data ? data.free.slice(0, viewVolume) : []} />
              </div>
              <div className={`${styles['recommend-button-box']}`}>
                <Link
                  to="/freesalon"
                  className={`${styles['button']} ${styles['button-blue']}`}
                >
                  <span
                    className={`${styles['button']} ${styles['button-icon-arrow']}`}
                  >
                    無料サロン一覧を見る
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className={`${styles['recommend']}`}>
          <div
            className={`${styles['recommend-inner']} ${styles['is-keyword']}`}
          >
            <div className={`${styles['recommend-content']}`}>
              <h2 className={`${styles['recommend-title']}`}>
                <div className={`${styles['recommend-title-text']}`}>
                  <span className={`${styles['recommend-title-color']}`}>
                    キーワード
                  </span>
                  からサロンを探す
                </div>
              </h2>
              <img
                className={`${styles['recommend-title-image']} ${styles['is-keyword']}`}
                src={title_keyword}
              />
              <div className={`${styles['recommend-keyword-list-wrap']}`}>
                <ul className={`${styles['recommend-keyword-list']}`}>
                  {landingPageFixedKeywords.map((k) => {
                    return (
                      <li
                        key={k.name}
                        className={`${styles['recommend-keyword-list-item']}`}
                      >
                        <Link
                          to={k.path}
                          className={`${styles['recommend-keyword-link']}`}
                        >
                          <div
                            className={`${styles['recommend-keyword-image']}`}
                            style={{
                              backgroundImage: `url(${k.image})`
                            }}
                          ></div>
                          <span
                            className={`${styles['recommend-keyword-title']}`}
                          >
                            {k.name}
                          </span>
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
              <div className={`${styles['recommend-tag-box']}`}>
                <ul
                  className={`${styles['button']} ${styles['button-tag-list']}`}
                >
                  {data &&
                    data.keywords.map((keyword) => (
                      <li
                        key={keyword.id}
                        className={`${styles['button']} ${styles['button-tag-item']}`}
                      >
                        <Link
                          to={`/keyword/${keyword.word_en}`}
                          className={`${styles['button']} ${styles['button-tag']}`}
                        >
                          {keyword.word}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
              <div className={`${styles['recommend-search-box']}`}>
                <div
                  className={`${styles['input']} ${styles['input-search-wrap']} ${styles['is-large']} ${styles['is-noicon']}`}
                >
                  <form
                    onSubmit={(e) => {
                      e.preventDefault()
                      toSearch()
                    }}
                  >
                    <input
                      className={`${styles['input']} ${styles['input-search']}`}
                      value={keyword}
                      placeholder="サロンを検索"
                      onChange={(e) => {
                        setKeyword(e.target.value)
                      }}
                      onKeyDown={handleSearchEnter}
                    />
                    <div
                      onClick={toSearch}
                      className={`${styles['input']} ${styles['input-search-button']}`}
                    ></div>
                  </form>
                </div>
              </div>
              <div className={`${styles['recommend-keyword-button-box']}`}>
                <Link
                  to="/keyword"
                  className={`${styles['button']} ${styles['button-blue']}`}
                >
                  <span
                    className={`${styles['button']} ${styles['button-icon-arrow']}`}
                  >
                    すべてのキーワードを見る
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className={`${styles['process']}`}>
          <div className={`${styles['process-inner']}`}>
            <h2 className={`${styles['process-title']}`}>
              <img
                src={icon_arrow}
                alt="矢印"
                className={`${styles['process-title-arrow']}`}
              />
              <p className={`${styles['process-title-text']}`}>
                オンラインサロン
                <br />
                参加の流れ
              </p>
              <p className={`${styles['process-title-lead']}`}>
                ONLINE SALON
                <br />
                PARTICIPATION PROCESS
              </p>
            </h2>
            <ul className={`${styles['process-list']}`}>
              {processList.map((p, i) => {
                return (
                  <li
                    key={i}
                    className={`${styles['process-list-item']} ${
                      i == 3 ? styles['is-blue'] : ''
                    }`}
                  >
                    <div className={`${styles['process-step-box']}`}>
                      {i === 3 ? 'FINISH' : 'STEP'}
                      {i + 1 !== 4 && (
                        <span className={`${styles['process-step-number']}`}>
                          {i + 1}
                        </span>
                      )}
                    </div>
                    <div className={`${styles['process-text-box']}`}>
                      <div
                        className={`${styles['process-image']}`}
                        style={{ backgroundImage: `url(${p.img})` }}
                      ></div>
                      <div className={`${styles['process-content']}`}>
                        {p.content}
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </section>
        <section className={`${styles['toppanel']}`}>
          <div className={`${styles['toppanel-filter']}`}>
            <div className={`${styles['toppanel-inner']}`}>
              <ul className={`${styles['toppanel-list']}`}>
                <li className={`${styles['toppanel-list-item']}`}>
                  <h3 className={`${styles['toppanel-title-box']}`}>
                    <p className={`${styles['toppanel-title-lead']}`}>
                      What can YOOR do?
                    </p>
                    <img
                      className={`${styles['toppanel-image']}`}
                      src={icon_beginner}
                      alt="YOORって何ができる？"
                    />
                    <p className={`${styles['toppanel-title']}`}>
                      YOORって何ができる？
                    </p>
                  </h3>
                  <p className={`${styles['toppanel-text']}`}>
                    YOORはコミュニティやファンクラブ、オンラインレッスンの場
                    <br className={`${styles['pc-only']}`} />
                    として利用できるオンラインサロンのプラットフォームです。
                    <br />
                    あなたにぴったりなサロンを見つけましょう。
                  </p>
                  <Link
                    to="/beginner"
                    className={`${styles['button']} ${styles['button-line-only']} ${styles['is-arrow']} ${styles['is-green']}`}
                  >
                    初めての方はこちら
                  </Link>
                </li>
                <li
                  className={`${styles['toppanel-list-item']} ${styles['is-blue']}`}
                >
                  <h3 className={`${styles['toppanel-title-box']}`}>
                    <p className={`${styles['toppanel-title-lead']}`}>
                      I want to create a salon.
                    </p>
                    <img
                      className={`${styles['toppanel-image']}`}
                      src={icon_create}
                      alt="みんなが集まるサロンを作りたい"
                    />
                    <p className={`${styles['toppanel-title']}`}>
                      みんなが集まるサロン
                      <br className={`${styles['tb-only']}`} />
                      を作りたい
                    </p>
                  </h3>
                  <p className={`${styles['toppanel-text']}`}>
                    YOORは個人は誰でも無料でサブスクの
                    <br />
                    オンラインサロンを始めることができます。
                    <br />
                    SNSやブログで活躍する個人のオーナーも活躍中です。
                  </p>
                  <Link
                    to="/opensalon"
                    className={`${styles['button']} ${styles['button-line-only']} ${styles['is-arrow']}`}
                  >
                    サロンを開設する
                  </Link>
                </li>
              </ul>
              <p className={`${styles['toppanel-note']}`}>
                ※流通取引総額16倍成長：2022年と2023年の1月〜3月の比較
              </p>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  )
}

const CreditcardAlert = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  padding: 16px;
  background: #fffe00 0% 0% no-repeat padding-box;
  color: #000;
  @media screen and (max-width: 640px) {
    padding: 8px 12px;
    font-size: 12px;
  }
  a {
    color: #11b5f5;
  }
`
